@if (reviews && reviews.length) {
<div class="center p-t-8-x p-t-8-l"
     [class.wrap]="variant === 'standard'"
     id="reviews">
    @if (variant === 'standard') {
    <div class="flex flex-justify-center flex-middle">
        <img [image]="'/assets/images/revio-logo.svg'"
             height="38">
        <div class="h1 m-l-5">{{'Reviews' | translate}}</div>
    </div>
    }
    @if (variant === 'standard') {
    <div
         class="p-b-5-m p-b-5-s b-b-m b-b-s b-col-42 m-t-2 m-t-3-m m-t-3-s m-b-5-m m-b-5-s flex flex-middle flex-justify-center">
        <span class="h4 m-r-2 m-r-4-m m-r-4-s"
              style="line-height: 1em;">{{reviewsRating}}</span>
        <rating class="inline-flex fs-9-x fs-9-l"
                [value]="reviewsRating"></rating>
        <span class="m-l"
              style="line-height: 1em;"
              sizeClass="XL:p1, MS:p2">({{reviewsCount}})</span>
    </div>
    }
    <div class="center">
        @for (review of sortedReviews | slice: offset : (offset + pagerSize); track $index; let i = $index; let isFirst
        = $first) {
        <product-reviews-item class="w-11 w-12-m w-12-s left p-t-4-x p-t-4-l m-b-1 m-b-6-m m-b-6-s"
                              [review]="review"
                              [variant]="variant"
                              [ngClass]="variant === 'modal' ? 'p-l-0 p-r-0' : 'p-r-7 p-r-2-m p-r-2-s p-l-7 p-l-2-m p-l-2-s'">
        </product-reviews-item>
        }
    </div>
    @if (displayMoreReviews) {
    <button type="button"
            class="button button-1 m-t-6 m-t-1-m m-t-1-s"
            (click)="displayMore()">{{'Show more reviews' | translate}}
    </button>
    }
    @if (!displayMoreReviews) {
    <reviews-pager #pager
                   [total]="reviews.length"
                   [variant]="'modal'"
                   [pageSize]="pagerSize"
                   class="w-12 flex flex-justify-center m-t-10 m-t-5-m m-t-5-s"
                   [class.m-b-8]="variant === 'modal'"
                   (pagerChange)="onPagerChange($event)"></reviews-pager>
    }
</div>
}